<template>
	<div class="live_show_page" id="target" :style="'padding-bottom:'+margin_bottom+'px' ">
		<div ref="offset_top" class="videod" v-if="playVideo">
			<video class="video_iframe" :src="video_url" autoplay="true" width="100%" controls controlslist="nodownload" loop='loop'></video>
			<!-- loop='loop' -->
			<!-- @onended="videoEnd()" -->
			<!-- <iframe
			class="video_iframe"
			style="z-index:1;"
			:src="video_url"
			allowfullscreen="true"
			frameborder="0"
			height="250"
			width="100%"
			>
		</iframe> -->
	</div>
	<div v-else>
		<video-player ref="offset_top" v-if="live_status==1&&showPlayer" class="video-player vjs-custom-skin"
		:playsinline="true"
		:options="playerOptions"
		></video-player>
		<div class="topicimg" ref="offset_top" :style="'background-image:url('+info.start_pic+')'" v-if="live_status==0">
			<div class="livetime">{{info.live_start_text}}</div>
			<div class="livetimewait">倒计时
				<div class="time_box">{{days}}</div>天
				<div class="time_box">{{hours}}</div>时
				<div class="time_box">{{minutes}}</div>分
				<div class="time_box">{{seconds}}</div>秒
			</div>
			<div>
				<img v-if="info.trailer_url" class="checkbtn" :src="img.checkbtn" @click="checkbtn">
			</div>
		</div>
		<!-- <div class="topicimg" ref="offset_top" :style="'background-image:url('+info.live_start_pic+')'" v-if="live_status==1&&live_start==2">
			<div class="livetime">{{info.live_start_text}}</div>
			<div>
				<img class="showlivepic" :src="img.showlive" @click="showlive">
			</div>
		</div> -->
		<div class="topicimg" ref="offset_top" :style="'background-image:url('+info.live_end_pic+')'" v-if="live_status==2">
			<img v-if="info.playback_url" class="playback" :src="img.playback" @click="playback">
			<div class="peopstime"><span v-if="info.watch_num>0">{{info.watch_num}}人次观看｜</span>{{info.live_start_text}}</div>
		</div>
	</div>
	<div class="show showtop" :style="'padding-top:'+padding_top+'px;'">
		<h3>
			<span class="posttitle">{{ info.title }}</span>
		</h3>
		<div class="media">
			<span>{{info.desc}}</span>
		</div>
		<div @click="showPopup" v-if="info.code_pic">
			<img class="live_join" :src="img.join">
		</div>
	</div>
	<!-- <div class="show" style="border-top: 10px solid #EEEEEE;display: flex;align-items: center;">
		<img class="motortimelogo" :src="img.motortimelogo">
		<div class="appname">汽车时间</div>
		<a class="btn" id="to_appstore" href="https://apps.apple.com/cn/app/%E6%B1%BD%E8%BD%A6%E6%97%B6%E9%97%B4/id1084608468"></a>
		<van-button type="primary" size="small" @click="openApp">打开APP,参与活动</van-button>
	</div> -->
	<van-sticky :offset-top='offset_top'>
		<div class="show" style="border-top: 10px solid #EEEEEE;">
			<div class="tab_box">
				<div :class="tabindex==1?'tabd active':'tabd'" @click="checktab(1)">
					互动空间
				</div>
				<div :class="tabindex==2?'tabd active':'tabd'" @click="checktab(2)">
					{{info.live_button_text}}
				</div>
			</div>
		</div>
	</van-sticky>
	<div class="showd" v-if="tabindex==1">
		<div class="live_state">尊敬的用户您好：我们倡导文明用语，绿色的交流环境。请不要发布任何涉及广告及色情 、恐怖、反动或反国家法律法规的消息。违禁者将被禁言。</div>
		<div class="comment_box" v-for="item in list" :key="'list_' + item.id">
			<span class="username" v-if="item.user">{{item.user.user_name?item.user.user_name:'匿名用户'}}：</span>
			<span class="username" v-else>匿名用户：</span>
			<span style="line-height: 1.6;color: #000;" v-if="item.content.length<13">{{item.content}}</span>
			<span style="line-height: 1.6;color: #056205;" v-if="item.content.length==13">{{item.content}}</span>
			<span style="line-height: 1.6;color: #1E2A74;" v-if="item.content.length==14">{{item.content}}</span>
			<span style="line-height: 1.6;color: #C40F0F;" v-if="item.content.length==15">{{item.content}}</span>
			<span style="line-height: 1.6;color: #000;" v-if="item.content.length==16">{{item.content}}</span>
			<span style="line-height: 1.6;color: #056205;" v-if="item.content.length==17">{{item.content}}</span>
			<span style="line-height: 1.6;color: #1E2A74;" v-if="item.content.length==18">{{item.content}}</span>
			<span style="line-height: 1.6;color: #C40F0F;" v-if="item.content.length==19">{{item.content}}</span>
			<span style="line-height: 1.6;color: #000;" v-if="item.content.length==20">{{item.content}}</span>
			<span style="line-height: 1.6;color: #C40F0F;" v-if="item.content.length>20">{{item.content}}</span>
		</div>
	</div>
	<div class="showd" v-else>
		<div v-html="info.content" class="content"></div>
	</div>
		<!-- <div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
		<div class="postbottom" id="inputid" v-if="inputshow">
			<van-row>
				<van-col span="19">
					<van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="输入评论..." ref="inputTag" />
				</van-col>
				<van-col span="5">
					<van-button color="#1F2A75" size="small" @click="post()" v-if="source==5">发表</van-button>
					<van-button color="#f6ab00" size="small" @click="post()" v-if="source==4">发表</van-button>
					<van-button color="#605C6B" size="small" @click="post()" v-if="source==9">发表</van-button>
				</van-col>
			</van-row>
		</div> -->
		<van-popup v-model="show">
			<img class="popimg" :src="info.code_pic">
		</van-popup>
	</div>
</template>
<script>
	import content from '../../../api/content';
	import common from '../../../api/common';
	import wxShare from '../../../api/wxShare';
	import {Row, Col, Tag,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Popup,Tab, Tabs,Sticky,Dialog} from "vant";
	import { mapState } from 'vuex';
	export default {
		data () {
			return {
				value:'',
				inputshow:true,
				live_id:'',
				overlay:false,
				inputfocus:false,
				inputnum:16,
				rid:'',
				info: '',
				params: {
					user_id: 0,

				},
				loading: false,
				finished: false,
				list: [],
				shareshow:false,
				show:false,
				tabindex:1,
				days: '88',
				hours: '88',
				minutes: '88',
				seconds: '88',
				offset_top:0,
				live_status:2,
				live_start:2,
				playVideo:false,
				video_url:'',
				liveYear:'',
				liveMonth:'',
				liveDay:'',
				liveHour:'',
				liveMin:'',
				margin_bottom:50,
				scrollBottom:true,
				scrollTop:110,
				disabled:false,
				showPlayer:false,
				img: {
					avatar: require('../../../assets/img/lexus/default.png'),
					show_parise: require('../../../assets/img/show_parise.png'),
					parise_have: require('../../../assets/img/lexus/parise_have.png'),
					show_no_parise: require('../../../assets/img/show_no_parise.png'),
					no_parise_have: require('../../../assets/img/lexus/no_parise_have.png'),
					collect: require('../../../assets/img/lexus/collect.png'),
					collect_have: require('../../../assets/img/lexus/collect_have.png'),
					comment: require('../../../assets/img/lexus/comment.png'),
					inrelay: require('../../../assets/img/lexus/inrelay.png'),
					outrelay: require('../../../assets/img/lexus/outrelay.png'),
					friends: require('../../../assets/img/lexus/friends.png'),
					wechat: require('../../../assets/img/lexus/wechat.png'),
					link: require('../../../assets/img/lexus/link.png'),
					poster: require('../../../assets/img/lexus/poster.png'),
					join: require('../../../assets/img/live/join.png'),
					checkbtn: require('../../../assets/img/live/check.png'),
					showlive: require('../../../assets/img/live/showlive.png'),
					playback:require('../../../assets/img/live/playback.png'),
					motortimelogo:require('../../../assets/img/motortimelogo.png'),
				},
				isWechat:true,
				isAndroid:true,
				isiOS:false,
				playerOptions : {
    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
    autoplay: false, //如果true,浏览器准备好时开始回放。
    muted: false, // 默认情况下将会消除任何音频。
    loop: false, // 导致视频一结束就重新开始。
    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    language: 'zh-CN',
    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    sources: [{
      type: "application/x-mpegURL",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
      src: "" //url地址
  }],
    poster: "", //你的封面地址
    // width: document.documentElement.clientWidth, //播放器宽度
    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
    controlBar: {
    	timeDivider: true,
    	durationDisplay: true,
    	remainingTimeDisplay: false,
      fullscreenToggle: true  //全屏按钮
  }
}
}
},
computed: {
	...mapState({
		user: state => state.param.user,
		source: state => state.param.source
	})
},
watch: {
	'$route'() {
		if(this.$route.params.id != this.live_id) {
			this.live_id = this.$route.params.id
			this.source = this.$route.params.source
			this.getInfo()
		}
	}
},
// mounted () {
// 	window.addEventListener('scroll', this.scrollToTop)
// },
created () {
	
	// console.log(encodeURIComponent('https://apps.apple.com/cn/app/%E6%B1%BD%E8%BD%A6%E6%97%B6%E9%97%B4/id1084608468'))

	var u = navigator.userAgent, app = navigator.appVersion;
	var ua = window.navigator.userAgent.toLowerCase();
	
	if(ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_'){
		this.isWechat=true
	}else{
		this.isWechat=false
	}
	this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
	this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	this.$store.commit('param/show', false)
	this.$appService.isShowReturn({state: true})
	this.$appService.isTabbar({state: true})
	if(this.$route.query.token){
		this.token = this.$route.query.token
		this.$store.dispatch('param/setToken', this.$route.query.token)
		this.params.user_id = this.$route.query.userid
	}
	let id = this.$route.params.id

	this.weburl=process.env.VUE_APP_URL
	if(this.$util.isEmpty(id)) {
		this.$toast('内容不存在')
		return false
	}
	this.live_id = id
	this.getInfo()
	this.getLiveStatus()
	this.getLiveComments()
	if(this.source==1){
		this.margin_bottom=0
		this.inputshow=false
	}
	const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(u);
	if(!isMobile){
		window.location.href = 'https://www.motortime.com/livenew/'+id
	}

},
activated () {
	this.$store.commit('param/show', false)
	this.$appService.isShowReturn({state: true})
	this.$appService.isTabbar({state: true})
	var offset_top=this.$refs.offset_top.offsetHeight
	if(offset_top){
		this.offset_top=this.$refs.offset_top.offsetHeight
		this.padding_top=this.$refs.offset_top.offsetHeight+10
	}else{
		var offset_top=this.$refs.offset_top.$refs.video.offsetHeight
		this.offset_top=this.$refs.offset_top.$refs.video.offsetHeight
		this.padding_top=this.$refs.offset_top.$refs.video.offsetHeight+10
	}
},
methods: {
	getInfo () {
		content.getLiveShow(this.live_id).then(res => {
			if(res.data.state == 1) {
				this.info = res.data.data
				this.playerOptions.sources[0].src=res.data.data.live_url
				this.playerOptions.poster=res.data.data.live_start_pic
				this.$util.title(res.data.data.title)
				var apppar={
					title:res.data.data.title
				}
				this.$appService.changeTitle(apppar)
				this.video_url=res.data.data.trailer_url
				this.live_status=res.data.data.live_status
				if(this.live_status==1){
					this.showPlayer=true
				}else{
					this.showPlayer=false
				}
				if(res.data.data.title){
					document.title = res.data.data.title;
				}
				var param={
					title:res.data.data.title,
					description:res.data.data.desc,
					pic_url:res.data.data.share_pic?res.data.data.share_pic:res.data.data.live_start_pic
				}
				content.getShare({url:encodeURI(location.href)}).then(res => {
					if(res.data.state == 1) {
						wxShare.getJSSDK(res.data.data, param)
					}
				})
				document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keywords)
				document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.desc)
				var live_start_time = res.data.data.live_start_time
				var newTime = new Date();
				this.timepoor(newTime, live_start_time)
				var newDate = new Date(live_start_time * 1000);
				var liveYear = newDate.getFullYear()
				var liveMonth = newDate.getMonth() + 1
				var liveDay = newDate.getDate()
				var liveHour = newDate.getHours()
				var liveMin = newDate.getMinutes()
				if (liveMonth < '10') liveMonth = "0" + liveMonth;
				if (liveDay < '10') liveDay = "0" + liveDay;
				if (liveHour < '10') liveHour = "0" + liveHour;
				if (liveMin < '10') liveMin = "0" + liveMin;
				this.liveYear=liveYear
				this.liveMonth=liveMonth
				this.liveDay=liveDay
				this.liveHour=liveHour
				this.liveMin=liveMin
				var params={
					event_code: '直播',
					event_id: this.info.id,
					title: this.info.title,
					value: '',
					path: '/Lexus/Content/Live.vue',
					user_id: this.user ? this.user.id : 0,
					source: this.source
				}
				common.BurialPoint(params).then(res => {
					if(res.data.state==1){
					}
				})

			}
		})
	},
	openApp(){
		if(this.isWechat){
			window.location.href='https://m.motortime.com/download'
		}else{
			if(this.isiOS){
				Dialog.confirm({
					message:
					'即将打开App Store，下载汽车时间',
					confirmButtonColor:'#576B95'
				})
				.then(() => {
					var obj=document.getElementById('to_appstore')
					obj.click()
				})
				.catch(() => {
				});
			}else{
				window.location = 'motortime://pages/index/index'; 
				window.setTimeout(function() {
					window.location = "https://pic.motortime.com/app/MOTORTIME/motortime.apk"; 
				}, 500);
			}
		}
	},
	//直播状态
	getLiveStatus() {
		content.getLiveStatus(this.live_id).then(res => {
			if(this.live_status!=res.data.data.live_status){
				this.live_status=res.data.data.live_status
				if(res.data.data.live_status==1){
					this.live_start=1
					this.showPlayer=true
					
				}else if(res.data.data.live_status==2){
					this.live_start=2
					this.showPlayer=false
				}
			}
			
			var that=this
			setTimeout(function () {
				that.getLiveStatus()
			}, 2000);
		})
	},
  //直播评论
  getLiveComments() {
  	this.params.source = this.source
  	content.getLiveComments(this.params,this.live_id).then(res => {
  		// this.list.push.apply(this.list, res.data.data.data)
  		this.list=res.data.data.data
  		if(this.scrollBottom){
  			document.getElementById("target").scrollIntoView(false);
  		}
  		
  		var that=this
  		setTimeout(function () {
  			that.getLiveComments()
  		}, 3000);
  	})
  },
  timepoor(date1, date2) {
  	var date = date2 * 1000
    var date3 = date - new Date(date1).getTime(); //时间差的毫秒数        
    //计算出相差天数  
    if (date3 > 0) {
    	var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数  
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数  
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数  
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
      var seconds = Math.round(leave3 / 1000);
      this.countdown(date2);
      if (days < '10') days = "0" + days;
      if (hours < '10') hours = "0" + hours;
      if (minutes < '10') minutes = "0" + minutes;
      if (seconds < '10') seconds = "0" + seconds;
      this.days=days
      this.hours=hours
      this.minutes=minutes
      this.seconds=seconds
      
  } else {

  	if (this.livestate == 0) {
  		this.live_start=1
  	}
  	this.days='00'
  	this.hours='00'
  	this.minutes='00'
  	this.seconds='00'

  }
},
// scrollToTop() {
// 	let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
// 	console.log('scrollTop==='+scrollTop)
// 	console.log('this.scrollTop==='+this.scrollTop)
// 	if(scrollTop<this.scrollTop){
// 		this.scrollBottom=false

// 	}else{
// 		document.getElementById("target").scrollIntoView(false);
// 		this.scrollBottom=true
// 		this.scrollTop=scrollTop
// 	}
// },
countdown(time) {
	var time=time 
	var that=this
	setTimeout(function () {
		var newTime = new Date();
		that.timepoor(newTime, time)
	}, 1000);
},
showPopup() {
	this.show = true;
},
checktab(tabindex){
	this.tabindex=tabindex
	if(tabindex==1){
		if(this.source==1){
			this.inputshow=false
		}else{
			this.inputshow=true
			this.margin_bottom=50
		}
		
		this.scrollBottom=true
		document.getElementById("target").scrollIntoView(false);
	}else{
		this.inputshow=false
		this.scrollBottom=false
		this.margin_bottom=0
		// if(this.scrollTop>110){
		// 	scrollTo(0,140);
		// }
	}
},
checkbtn(){//看预告
	this.playVideo=true
	this.video_url=this.info.trailer_url
},
showlive(){//看直播
	this.live_start=1
},
playback(){//看回放
	this.playVideo=true
	this.video_url=this.info.playback_url
},
// videoEnd(e){
// console.log('videoEnd======')
// },
      inputFocus(){//点击输入框聚焦
      	// this.inputshow=false;
      	this.overlay=true;
      	this.inputnum=19;
      	setTimeout(() => {
      		var cc=document.getElementById('inputid');
      		cc.scrollIntoViewIfNeeded(true);
      		// document.getElementById("target").scrollIntoView(false);
      	},500);
      	
      },
      touchstart(){//检测触发遮罩层，失去焦点
      	this.inputshow=true;
      	this.overlay=false;
      	this.$refs.inputTag.blur()
      	this.inputnum=16;
      	this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
      	setTimeout(() => {
      		this.inputshow=true;
      		this.inputnum=16;
      	}, 1000);
      	this.overlay=false;
      	this.inputfocus=false
      	this.$refs.inputTag.blur()
      },
      post(){
      	if(!this.disabled){
      		this.disabled=true
      		let params={
      			live_id:this.live_id,
      			content:this.value
      		}
      		content.LiveComment(params).then(res => {
      			this.disabled=false
      			if(res.data.state == 1) {
      				this.scrollBottom=true
      				this.inputshow=true;
      				this.inputnum=16;
      				this.overlay=false;
      				this.inputfocus=false
      				this.$refs.inputTag.blur()
      			// this.$toast.success('发表成功')
      			this.value=''
      			this.getLiveComments()
      			document.getElementById("target").scrollIntoView(false);
      		}
      	})
      	}
      	
      },
      onCancel(){
      	this.actionshow=false
      },
      
      onLoad() {
      	this.params.user_id = this.user ? this.user.id : 0
      	setTimeout(() => {
      	}, 500);
      },
  },
  components: {
  	[Row.name]: Row,
  	[Col.name]: Col,
  	[Grid.name]: Grid,
  	[GridItem.name]: GridItem,
  	[Tag.name]: Tag,
  	[List.name]:List,
  	[Field.name]:Field,
  	[Button.name]:Button,
  	[Overlay.name]:Overlay,
  	[ActionSheet.name]:ActionSheet,
  	[Divider.name]:Divider,
  	[Popup.name]:Popup,
  	[Sticky.name]:Sticky,
  	[Dialog.name]:Dialog
  }
};
</script>

<style lang="scss">
	.live_show_page {
		background-color: #F0F0F0;

		.img{
			width: 100%;
			height: 221px;
			display: block;
			object-fit: cover;
		}
		.vjs-custom-skin > .video-js{
			height: 221px;
		}
		.video-player{
			width: 100%;
			position:fixed;
			background-color: #fff;
			z-index: 1000;
			/*height: 250px !important;*/
		}
		.videod{
			width: 100%;
			position: fixed;
			background-color: #fff;
			height: 221px;
			.video_iframe{
				width: 100%;
				height: 221px;
			}
		}
		.topicimg{
			width: 100%;
			height: 221px !important;
			background-size: 100% 221px;
			object-fit: cover;
			color: #fff;
			position: fixed;
			background-repeat: no-repeat;
			background-position: center;
			text-align: center;
			z-index: 999;
			background-color: #fff;
			.livetime{
				font-size: 14px;
				padding-top: 70px;
			}

			.livetimewait{
				font-size: 16px;
				margin-top: 25px;
				font-weight: 400;
				text-align: center;
				display: flex;
				align-items:center;
				justify-content: center;
				.time_box {
					width: 30px;
					height: 30px;
					background-color: #fff;
					margin: 5px;
					border-radius: 5px;
					color: #3A3A3A;
					display: flex;
					align-items:center;
					justify-content: center;
				}
			}
			.checkbtn{
				width: 80px;
				height: 26px;
				margin-top: 20px;
			}
			.showlivepic{
				width: 140px;
				height: 40px;
				margin-top: 30px;
			}
			.playback{
				width: 64px;
				height: 64px;
				margin-top: 20%;
			}
			.peopstime {
				color: #797979;
				font-size: 14px;
				text-align: left;
				background-color: #D8D8D8;
				padding: 3px 10px;
				position: absolute;
				bottom: 0;
				width: 100%;
			}
		}
		.posttitle{
			vertical-align: middle;
		}
		.live_join{
			width: 100%;
			height: 45px;
		}
		.mr-10{
			margin-right: 10px;
		}
		.show {
			padding: 10px;
			background-color: #FFF;
			font-size: 14px;
			color: #3A3A3A;
			h3 {
				font-size: 17px;
				margin: 0;
			}

			.mt-40{
				margin-top: 40px;
			}
			.media {
				color: #9A9A9A;
				font-size: 12px;
				margin: 12px 0;
				text-indent:2em;
				img {
					width: 30px;
					border-radius: 15px;
					vertical-align: middle;
				}
			}

			.tab_box{
				/*font-size: 16px;*/
				position: relative;
				display: flex;

				.tabd{
					color: #797979;
					position: relative;
					margin-right: 20px;

				}
				.active{
					color: #3A3A3A;
					padding-bottom: 5px;
					border-bottom: 2px solid #3A3A3A;
				}
			}
			.motortimelogo{
				width: 40px;
				height: 40px;
				border-radius: 50px;
				margin-right: 10px;
			}
			.appname{
				flex: 1;
				font-size: 14px;
				font-weight: bold;
			}
			.appbtn{
				padding: 0 15px;
				height: 30px;
				color: #fff;
				font-size: 14px;
				border-radius: 5px;
				background-color: blue;

			}
		}
		.showd{
			padding: 10px;
			background-color: #EEEEEE;
			font-size: 14px;
			color: #3A3A3A;
			.live_state{
				font-size: 10px;
				color: #9A9A9A;
			}
			.comment_box{
				font-size: 12px;
				color: #000000;
				margin-top: 15px;
				.username{
					color: #1F2A75;
					font-weight: bold;
				}
			}
			.content {
				margin-top: 0px;
				font-size: 14px !important;
				line-height: 2 !important;
				img {
					max-width: 100%;
					object-fit:cover;
					line-height: 0 !important;
				}
				iframe{
					max-width: 100%;
				}
				video{
					max-width: 100%;
				}
			}
			.content iframe{
				width: 100%;
				height: 200px;
			}
			.content video{
				width: 100%;
				height: 200px;
			}
		}
		.borderleft{
			margin-right: 10px;
			border-left: 3px solid #3A3A3A;
		}
		a{
			color: #3A3A3A;
		}

		.van-popup{
			max-height: 360px;
			width: 80%;
			border-radius: 8px;
			overflow-y: hidden;
			background-color: transparent;
			.van-action-sheet__cancel::before{
				height: 1px;
			}
			.divider{
				margin: 20px 80px;
			}
			.popimg{
				width: 100%;
				height: 360px
			}
		}
	}
</style>
